import { Box, Typography } from '@wishket/design-system';
import { twJoin, twMerge } from 'tailwind-merge';

import { SubCount } from './ArticleCount.parts';

import { ArticleCountProps } from '@/shared/types';

const ArticleCount = ({
  rank,
  changedCount,
  articleCountTypoClassName,
}: ArticleCountProps) => {
  const isNotChanged = changedCount === 0;

  return (
    <Box
      className={twJoin(
        'flex w-7 flex-col items-center',
        isNotChanged ? 'gap-3' : 'gap-1.5'
      )}
      data-testid="article-count-root"
    >
      <Typography
        variant="body1"
        className={twMerge(
          'font-bold text-w-gray-900',
          articleCountTypoClassName
        )}
      >
        {rank}
      </Typography>
      <SubCount changedCount={changedCount} />
    </Box>
  );
};

export default ArticleCount;
